function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  x: 0.5,
  y: 0.5,
  stroke: "#0EFBA7",
  rx: 3
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0EFBA7",
  d: "M3.408 8.439l3.009 2.885 6.965-6.547 1.726 1.726-8.691 8.273-4.735-4.611z"
}));
function SvgIconVerifiedBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17"
  }, props), _ref);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='17' height='17' viewBox='0 0 17 17'%3e %3cg fill='none' fill-rule='evenodd'%3e %3crect width='16' height='16' x='.5' y='.5' fill-rule='nonzero' stroke='%230EFBA7' rx='3'/%3e %3cpath fill='%230EFBA7' d='M4.795 4.882L4.882 9.049 14.436 9.345 14.436 11.786 2.441 11.49 2.354 4.882z' transform='rotate(-45 8.395 8.334)'/%3e %3c/g%3e %3c/svg%3e";
export { SvgIconVerifiedBorder as ReactComponent };